import { addCurrencyToPrice } from 'utils/price';
import { BundleCatalogPlan } from 'types/generated/subscriptionsApi';
import getPlanPrices from 'helpers/getPlanPrices/getPlanPrices';
import { BundleCatalog } from '@landr/pricing/lib/types/generated';
import { GetDiscountedPlan } from 'hooks/useGetDiscountedPlan/useGetDiscountedPlan';

export const getStudioPrice = ({
    studioCatalog,
    getDiscountedPlan,
}: {
    studioCatalog?: BundleCatalog;
    getDiscountedPlan: GetDiscountedPlan;
}) => {
    const studioYearly = studioCatalog?.plans.find(
        (plan: BundleCatalogPlan) => plan?.frequency === 'Yearly',
    );

    const discountedStudio = getDiscountedPlan({
        planCode: 'all_access',
        frequency: 'Yearly',
    });

    const studioPriceWithCurrency = addCurrencyToPrice(
        studioCatalog ? studioCatalog?.currency : undefined,
        studioYearly?.monthlyEquivalentPrice ?? undefined,
    );

    const { monthlyEquivalentSalePrice: studioMonthlyEquivalentSalePrice } =
        getPlanPrices({
            monthlyEquivalentPrice: studioYearly?.monthlyEquivalentPrice,
            discountPercentage: discountedStudio?.discountPercentage,
        });

    const studioSalesWithCurrency = addCurrencyToPrice(
        studioCatalog?.currency ?? undefined,
        studioMonthlyEquivalentSalePrice ?? undefined,
    );

    return { studioPriceWithCurrency, studioSalesWithCurrency };
};
